import React, { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { addListingDetailsType } from '~addListing/types';
import { Icon, Input } from '@aqarmap/aqarmap-ui';
import Tooltip from '~/components/Tooltip';
import { useBreakpoint } from '~/hooks';

const ContractPrice = ({
  defaultContractPrice,
}: {
  defaultContractPrice: number;
}) => {
  const { t } = useTranslation('app');
  const { mobileScreen } = useBreakpoint();

  const {
    setValue,
    formState: { errors },
  } = useFormContext<addListingDetailsType>();
  const paymentPlans = useWatch({ name: 'paymentPlans' });
  const paymentMethod = useWatch({ name: 'paymentMethod' });
  const contractPriceValue = paymentPlans?.[0]?.price || 0;

  const handleChange = (value: string) => {
    setValue('paymentPlans.0.price', Number(value.split(',').join('')) ?? '');
  };

  useEffect(() => {
    setValue('paymentPlans.0.price', defaultContractPrice);
  }, [defaultContractPrice, paymentMethod]);

  return (
    <Input
      label={{
        component: (
          <p className="text-title-4 flex gap-x items-center">
            <span>{t('contractPrice')}</span>
            <Tooltip
              text={t('contractPriceTooltip')}
              className="max-w-[272px]"
              id="contract-price-tooltip"
              children={
                <Icon name="info" size="16px" className="text-gray__dark_2" />
              }
            />
          </p>
        ),
      }}
      field={{
        type: 'text',
        placeholder: t('contractPrice'),
        onChange: (e) => handleChange(e.target.value),
        value: contractPriceValue ? contractPriceValue?.toLocaleString() : '',
      }}
      className="flex-1"
      endIcon={
        <p className="border-s ps-x border-gray text-body_2 text-gray__dark_1">
          {mobileScreen ? t('pound') : t('egyptianPound')}
        </p>
      }
      error={errors.paymentPlans?.[0]?.price ? t('contractPriceRequired') : ''}
    />
  );
};

export default ContractPrice;
